<template>
    <CDropdown inNav
               class="c-header-nav-items"
               placement="bottom-end"
               add-menu-classes="pt-0" v-if="otherAppsAvailable">
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <i class="fas fa-th-large"></i>
                    <img src="../../public/img/th-large-solid.svg" class="navyBlue" /> 
                    <!--<font-awesome-icon icon="fa-solid fa-user-secret" style="color:palegreen" />-->
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div"
                         class="text-center"
                         color="light">
            <strong>Available Apps</strong>
        </CDropdownHeader>
        <li v-for="app in availableApps">
            <CDropdownItem v-if="hasAccess(app.name)" @click="navigateToApp(app.url)">
                <img :src="app.image" width="100"/>
            </CDropdownItem>
        </li>
    </CDropdown>
</template>

<script>
    import Vue from 'vue'
    import urls from '../common/urls'
    import apis from '../common/network'
    import authToken from '../common/authToken'
    import VueJwtDecode from 'vue-jwt-decode'
    import Cookies from 'js-cookie'

    /* import the fontawesome core */
    import { library } from '@fortawesome/fontawesome-svg-core'

    /* import font awesome icon component */
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    /* import specific icons */
    import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
    library.add(faUserSecret)
    Vue.component('font-awesome-icon', FontAwesomeIcon)

    export default {
        name: 'TheHeaderDropdownAccnt',
        data() {
            return {
                otherAppsAvailable: true,
                apps: [

                    {
                        name: 'Resolve',
                        url: urls.resolveBaseUrl,
                        image: require("../../public/img/resolve_demo_v3.png")
                    },
                    {
                        name: 'TOC',
                        url: urls.tocBaseUrl,
                        image: require("../../public/img/recharge_demo_v3.png")
                    },
                    {
                        name: 'Assure',
                        url: urls.assureBaseUrl,
                        image: require("../../public/img/assure_demo_v3.png")
                    },
                ],
                appsProd: [
                    {
                        name: 'Ithelpdesk',
                        url: urls.helpDeskUrl,
                        image: require("../../public/img/Helpdesk_prod_v3.png")
                    },
                    {
                        name: 'Resolve',
                        url: urls.resolveBaseUrl,
                        image: require("../../public/img/resolve_v3.png")
                    },
                    {
                        name: 'TOC',
                        url: urls.tocBaseUrl,
                        image: require("../../public/img/recharge_v3.png")
                    },
                    {
                        name: 'Assure',
                        url: urls.assureBaseUrl,
                        image: require("../../public/img/assure_v3.png")
                    },
                ]
               
            }
        },
        methods: {
            hasAccess: function (appName) {
                return true;
            },
            
            navigateToApp: function (appUrl) {
                window.location.replace(appUrl)
            },
            logout: function () {
                authToken.get();
                localStorage.clear();
                window.location.replace(`${urls.resolveBaseUrl}`)
            },
            resolveBaseUrl: function () {
                apis.navigateToLogin(window.location.pathname)
            },
        },
        computed: {
            availableApps() {
                var decodedToken = VueJwtDecode.decode(authToken.get());
                var ssoDecodedToken = VueJwtDecode.decode(decodedToken.ssoToken);
                var location = window.location.href;


                if (location !== "https://rm2.alfaenergygroup.com/home") {
                    var apps = this.apps.filter(tg => ssoDecodedToken[tg.name] !== undefined)
                    this.otherAppsAvailable = apps.length > 0;

                } else {
                    var apps = this.appsProd.filter(tg => ssoDecodedToken[tg.name] !== undefined);
                    this.otherAppsAvailable = apps.length > 0;

                }

                //var apps = location !== 'https://rm2alfaenergygroup.com' ? this.apps.filter(tg => ssoDecodedToken[tg.name] !== undefined) : this.appsProd.filter(tg => ssoDecodedToken[tg.name] !== undefined);
                ////var apps = this.apps.filter(tg => ssoDecodedToken[tg.name] !== undefined);
                //this.otherAppsAvailable = apps.length > 0;
                return apps;
            },
          
        },
    }
</script>

<style scoped>
    .c-icon {
        margin-right: 0.3rem;
    }

    .navyBlue {
        filter: invert(27%) sepia(13%) saturate(7476%) hue-rotate(215.2deg) brightness(56.7%) contrast(98%);
        color: #001c55;
    }
</style>